/**
 * Stripe product/price mapping for CEO subscription tiers.
 * These IDs match the Stripe products created for the founder pricing page.
 */
export const STRIPE_TIERS = {
  basic: {
    product_id: "prod_TwWMdLJdhLGqEV",
    price_id: "price_1SydJLRugD17hXY31bKBTDRt",
    name: "Basic",
    price: "$299",
    interval: "month",
  },
  pro: {
    product_id: "prod_TwWMgzoElblgBG",
    price_id: "price_1SydJrRugD17hXY3P0RnLZx0",
    name: "Pro",
    price: "$599",
    interval: "month",
  },
  enterprise: {
    product_id: null,
    price_id: null,
    name: "Enterprise",
    price: "Custom",
    interval: null,
  },
} as const;

export type StripeTierKey = keyof typeof STRIPE_TIERS;
